<div class="form-text-container" [class.has-error]="shouldShowErrors()">
  <label *ngIf="label" [for]="id || name" class="form-text-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="form-text-wrapper">
    <input
      [attr.maxlength]="maxlengthSize"
      [type]="type"
      [id]="id || name"
      [name]="name"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [pattern]="pattern"
      [autocomplete]="autocomplete"
      [class]="'form-text-field ' + class"
      [value]="control ? control.value : value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />

    <div *ngIf="help" class="help-text">
      {{ help }}
    </div>
  </div>

  <!-- Error messages -->
  <div *ngIf="shouldShowErrors()" class="error-messages">
    <ng-content></ng-content>
  </div>
</div>
